/**
 * Inference ids that belong to Stories scene renders. Stories shows their progress on its own
 * stage, so the global "generation ready" toast skips them (live test: a scene render popped
 * "Image generated · View" pointing at the playground, where Stories renders are hidden).
 * In-memory for the session; the Stories client registers ids from takes and render responses.
 */
const ids = new Set<number>();

export function markStoryInferences(inferenceIds: Iterable<number | null | undefined>): void {
  for (const id of inferenceIds) if (typeof id === 'number') ids.add(id);
}

export function isStoryInference(id: number | null | undefined): boolean {
  return typeof id === 'number' && ids.has(id);
}
